"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueObject = void 0;
class ValueObject {
    _value;
    constructor(_value) {
        this._value = _value;
        this.validate();
    }
    get value() {
        return this._value;
    }
    equals(other) {
        if (!other)
            return false;
        if (this.constructor !== other.constructor)
            return false;
        return this.isEqual(other);
    }
    toString() {
        return String(this._value);
    }
    getEqualityComponents() {
        return [this._value];
    }
    isEqual(other) {
        return JSON.stringify(this.getEqualityComponents()) === JSON.stringify(other.getEqualityComponents());
    }
}
exports.ValueObject = ValueObject;
